__turbopack_context__.v({
  "list": "PerformerNamesList-module-scss-module__oZkxRq__list",
});
